import React, { Component } from "react";
import {Context} from "store/Context";
import DicesService from "../../services/DicesService";
import StrapsService from "../../services/StrapsService";

export default class Preloader extends Component {
  componentDidMount() {
    let dices = DicesService.getDices();
    dices.forEach((dice) => {
      this.preloadImg(dice.image);
    });

    let straps = StrapsService.getStraps();
    straps.forEach((strap) => {
      strap.images.forEach((image, key ) => {
        this.preloadImg(image['image'+key]);
      });
    });
  }

  preloadImg = url => {
    let img = new Image();
    img.src = url;
  }

  render() {
    return (
      <div></div>
    );
  }
}
Preloader.contextType = Context;
